<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Healthy Happy Vegan Kitchen</title>
<link href="../styles/style.css" rel="stylesheet" type="text/css"/>
<meta charset="utf-8"/>
<span epub:type="pagebreak" id="page34" title="34">
<div class="heading01">
<h1 class="running-hed" id="AA1">SCRAMBLES AND EGGLESS</h1>
</div>
<figure>
<img alt="" id="page0036" src="images/page036.jpg"/>
</figure>
<h1 class="recipe-title" id="AA2">EASY TOFU SCRAMBLE</h1>
<p class="recipe-headnote">This is my go-to tofu scramble recipe. It can be whipped up in just a few minutes and provides a protein-rich hot breakfast. You can even make this on a busy weekday morning! And the best part about this simple recipe is that you can change it up as you’d like based on the veggies and spices you have on hand. Toss in a handful of spinach. Add some vegan cheese shreds. Sprinkle in some Cajun spices or add diced bell pepper, mushrooms, or kale. So many variation possibilities! Keep some tofu in your fridge so you’ll always be ready to make this recipe.</p>
<p class="yield">SERVES 2</p>
<ul class="ing-list">
<li class="ingred">12 ounces firm or extra-firm tofu</li>
<li class="ingred">Nonstick cooking spray or oil</li>
<li class="ingred">1 teaspoon vegan buttery spread</li>
<li class="ingred">½ cup diced onion</li>
<li class="ingred">Other veggies (mushrooms, bell pepper, carrots, scallions, etc.; optional)</li>
<li class="ingred">1 cup chopped greens, such as fresh baby spinach, kale, or chard</li>
<li class="ingred">1 tablespoon tamari</li>
<li class="ingred">1 teaspoon grade B maple syrup</li>
<li class="ingred">⅓ cup nutritional yeast, plus more as desired </li>
<li class="ingred">¼ teaspoon freshly ground black pepper, plus more as desired</li>
<li class="ingred">½ to 1 teaspoon ground turmeric</li>
<li class="ingred">A few pinches of freshly grated orange zest (optional)</li>
<li class="ingred">Sea salt </li>
<li class="ingred">Optional add-ins: vegan cheese shreds, <span href="#/html/page062" title="Link target outside of Sample">Tempeh Bacon Bits</span>, additional spices</li>
</ul>
<table class="method">
<tbody><tr><td class="stepnum"><p class="step-num">1</p></td>
<td><p class="step">Drain the tofu of excess liquid and press it dry with paper towels.</p></td></tr>
<tr><td class="stepnum"><p class="step-num">2</p></td>
<td><p class="step">Coat a nonstick or cast-iron skillet with nonstick spray. Heat the pan over high heat. Add the vegan buttery spread. When the butter has melted and coats the pan, add the onion and any additional chopped veggies (if using). If the greens you’re using are hearty, like kale or chard, add them now. Cook the veggies, flipping them with a spatula, until the edges brown and caramelize, about 2 minutes.</p></td></tr>
<tr><td class="stepnum"><p class="step-num">3</p></td>
<td><p class="step">Using your hands, crumble the tofu into the pan. Break apart any big pieces using a spatula. Drizzle the tamari and maple syrup over the top. Sprinkle the nutritional yeast, pepper, turmeric, and orange zest (if using), over the top as well. Flip and toss the tofu with the seasonings and veggies. Continue cooking until the tofu appears to have firmed up a bit as it absorbs the flavors and lets off steam, 2 to 3 minutes more. Fold in the more delicate greens like spinach (if using). Allow the hot pan and tofu to gently wilt the greens into the mixture.<span epub:type="pagebreak" id="page35" title="35"></span></p></td></tr>
<tr><td class="stepnum"><p class="step-num">4</p></td>
<td><p class="step">Taste a bit of the tofu and add nutritional yeast, pepper, and salt to taste. Remove the pan from the heat and transfer to serving plates. Serve warm.</p></td></tr>
</tbody></table>
<p class="tip"><strong class="tip-leadin">Tip:</strong> Black salt and truffle salt both add a wonderful savory flavor to tofu scrambles. Pink salt is another favorite.</p>
<p class="tip"><strong class="tip-leadin">Tip:</strong> Some flavor boosters to make your tofu scramble more “eggy” are truffle oil or salt, black salt, or ume vinegar.</p>
<div class="fact">
<h2 class="nutr-hed">NUTRITION FACTS</h2>
<p class="nutr-param">(per serving–252g)</p>
<p class="nutr">Calories: 248; Fat: 10g; Carbs: 17g; Protein: 25g; Fiber: 7g<br/>Vitamin C: 15%; Iron: 34%; Calcium: 37%; Vitamin A: 22%</p>
</div>
</span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page034.vue?f8b4c638